// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outerDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: rgb(248, 252, 252);
}

.outerDiv * {
  font-family: Lato, Arial, sans-serif;
}

/*
  For splitting Ingredients & Instructions into two columns.
  Based on https://www.w3schools.com/howto/howto_css_split_screen.asp.
*/

/* Viewport for absolutely-positioned elements inside (class "split"). */
.splitViewport {
  position: relative;
  flex: 1 0 auto;
  width: 900px;
}

/* Split the screen in half */
.split {
  height: 100%;
  width: 50%;
  position: absolute;
  z-index: 1;
  top: 0;
  overflow-x: hidden;
  padding-top: 20px;
  box-sizing: border-box;
}

/* Control the left side */
.left {
  left: 0;
  background-color: rgb(225, 238, 233);
}

.left * {
  font-size: 14pt;
}

/* Control the right side */
.right {
  right: 0;
  background-color: rgb(238, 246, 253);
}

.right * {
  font-size: 12pt;
}

/* If you want the content centered horizontally */
.centered {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
}

.title {
  font-size: 20pt;
  font-weight: bold;
  text-align: center;
}

.instructions {
  width: 100%;
  padding: 0 30px 10px 30px;
  box-sizing: border-box;
}

/* Mess with Quill's sizing. */
.ql-container,
.ql-editor {
  min-height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/recipe-component/recipe.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;CAGC;;AAED,wEAAwE;AACxE;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,OAAO;EACP,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;;EAEE,iBAAiB;AACnB","sourcesContent":[".outerDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  background-color: rgb(248, 252, 252);\n}\n\n.outerDiv * {\n  font-family: Lato, Arial, sans-serif;\n}\n\n/*\n  For splitting Ingredients & Instructions into two columns.\n  Based on https://www.w3schools.com/howto/howto_css_split_screen.asp.\n*/\n\n/* Viewport for absolutely-positioned elements inside (class \"split\"). */\n.splitViewport {\n  position: relative;\n  flex: 1 0 auto;\n  width: 900px;\n}\n\n/* Split the screen in half */\n.split {\n  height: 100%;\n  width: 50%;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  overflow-x: hidden;\n  padding-top: 20px;\n  box-sizing: border-box;\n}\n\n/* Control the left side */\n.left {\n  left: 0;\n  background-color: rgb(225, 238, 233);\n}\n\n.left * {\n  font-size: 14pt;\n}\n\n/* Control the right side */\n.right {\n  right: 0;\n  background-color: rgb(238, 246, 253);\n}\n\n.right * {\n  font-size: 12pt;\n}\n\n/* If you want the content centered horizontally */\n.centered {\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n}\n\n.title {\n  font-size: 20pt;\n  font-weight: bold;\n  text-align: center;\n}\n\n.instructions {\n  width: 100%;\n  padding: 0 30px 10px 30px;\n  box-sizing: border-box;\n}\n\n/* Mess with Quill's sizing. */\n.ql-container,\n.ql-editor {\n  min-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
